import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu/menu.component';
import { IonicModule } from '@ionic/angular';
import { NavbarComponent } from './navbar/navbar.component';
import { DistribuidorComponent } from './distribuidor/distribuidor.component';
import { SuperAdminComponent } from './super-admin/super-admin.component';
import { NavbarProdComponent } from './navbar-prod/navbar-prod.component';
import { VistaRuterosComponent } from './vista-ruteros/vista-ruteros.component';
import { VistaSemillasComponent } from './vista-semillas/vista-semillas.component';
import { NgCircleProgressModule } from 'ng-circle-progress';

import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { RuterosComponent } from './ruteros/ruteros.component';
import { FormsModule } from '@angular/forms';
import { FilterPipe } from '../pipes/filter.pipe';


@NgModule({
  declarations: [MenuComponent,
    RuterosComponent,
    DistribuidorComponent,
    NavbarComponent,
    SuperAdminComponent,
    VistaRuterosComponent,
    VistaSemillasComponent,
    NavbarProdComponent,
    FilterPipe
  ],
  imports: [

    CommonModule,
    IonicModule,
    FormsModule,
    Ng2SearchPipeModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 60,
      outerStrokeWidth: 10,
      innerStrokeWidth: 10,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
     /*  outerStrokeGradient: true, */
      space: -10,
      /* radius: 60,
      space: -10,
      outerStrokeGradient: true,
      outerStrokeWidth: 10,
      outerStrokeColor: "#4882c2",
      outerStrokeGradientStopColor: "#53a9ff",
      innerStrokeColor: "#e7e8ea",
      innerStrokeWidth: 10,
      title: "UI",
      animateTitle: false,
      animationDuration: 1000,
      showUnits: false,
      showBackground: false,
      clockwise: false,
      startFromZero: false,
      lazy: true */
      
    }),
  ],
  exports: [
    MenuComponent,
    NavbarComponent,
    DistribuidorComponent,
    VistaSemillasComponent,
    VistaRuterosComponent,
    SuperAdminComponent,
    NavbarProdComponent,
    RuterosComponent

  ],
  
  
})
export class ComponentsModule { }
